import React, { useCallback, useMemo } from 'react'

const Pagination = ({ currentPage, totalPages, items, limit, handlePageChange }) => {

    const handleClick = useCallback((page) => {
        if (page >= 1 && page <= totalPages) {
            handlePageChange(page);
        }
    }, [totalPages, handlePageChange]);

    const pageNumbers = useMemo(() => Array.from({ length: totalPages }, (_, i) => i + 1), [totalPages]);

    return (
        <div className="table-pagination">
            <nav aria-label="Page navigation example">
                <ul className="pagination justify-content-end mb-0 gap-2">
                    <li className={`page-item prev-page ${currentPage === 1 ? 'disabled' : ''}`}>
                        <button className="page-link" onClick={() => handleClick(currentPage - 1)}>Previous</button>
                    </li>
                    {totalPages <= 5 ? (
                        pageNumbers.map((page) => (
                            <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                                <button className="page-link" onClick={() => handleClick(page)}>{page}</button>
                            </li>
                        ))
                    ) : (
                        <>
                            {/* Always show the first page */}
                            <li className={`page-item ${currentPage === 1 ? 'active' : ''}`}>
                                <button className="page-link" onClick={() => handleClick(1)}>1</button>
                            </li>

                            {/* Show dots if currentPage > 3 */}
                            {currentPage > 3 && (
                                <li className="page-item disabled">
                                    <span className="page-link">...</span>
                                </li>
                            )}

                            {/* Show middle pages */}
                            {[
                                currentPage - 1,
                                currentPage,
                                currentPage + 1
                            ].filter(page => page > 1 && page < totalPages).map((page) => (
                                <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                                    <button className="page-link" onClick={() => handleClick(page)}>{page}</button>
                                </li>
                            ))}

                            {/* Show dots if currentPage is not near the end */}
                            {currentPage < totalPages - 2 && (
                                <li className="page-item disabled">
                                    <span className="page-link">...</span>
                                </li>
                            )}

                            {/* Always show the last page */}
                            <li className={`page-item ${currentPage === totalPages ? 'active' : ''}`}>
                                <button className="page-link" onClick={() => handleClick(totalPages)}>{totalPages}</button>
                            </li>
                        </>
                    )}
                    <li className={`page-item next-page ${(currentPage === totalPages || totalPages === 0) ? 'disabled' : ''}`}>
                        <button className="page-link" onClick={() => handleClick(currentPage + 1)}>Next</button>
                    </li>
                </ul>
            </nav>
        </div>
    )
}

export default Pagination